<template>
  <div class="p-tasklist-proposal-action">
    <p class="p-tasklist-proposal-action__count">全{{ total }}件</p>
    <div class="p-tasklist-proposal-action__btns">
      <p>選択した項目を</p>
      <div class="c-alertPos">
        <Button
          fsize="f12"
          class="p-tasklist-proposal-action__reject"
          :class="{
            'is-loading': isProcessing.reject,
            'is-inactive': isInactive
          }"
          :disabled="isProcessing.accept || isProcessing.reject"
          @click="reject"
        >
          提案から外す
        </Button>
        <Alert v-if="errorResponses.reject.length">
          {{ errorResponses.reject[0] }}
        </Alert>
      </div>
      <div class="c-alertPos">
        <Button
          variant="main"
          fsize="f12"
          icon="plus"
          class="p-tasklist-proposal-action__accept"
          :class="{
            'is-loading': isProcessing.accept,
            'is-inactive': isInactive
          }"
          :disabled="isProcessing.accept || isProcessing.reject"
          @click="accept"
        >
          タスクに登録する
        </Button>
        <Alert v-if="errorResponses.accept.length">
          {{ errorResponses.accept[0] }}
        </Alert>
      </div>
    </div>
  </div>
</template>

<script>
import { USAGE_LABEL } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import apiProjects from '@/api/projects';
import utils from '@/utils';

export default {
  props: {
    checked: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  components: {
    Alert,
    Button
  },
  data() {
    return {
      errorResponses: {
        accept: [],
        reject: []
      },
      usages: {
        rest: 0
      },
      isOver: false,
      isProcessing: {
        accept: false,
        reject: false
      }
    };
  },
  computed: {
    count() {
      return this.checked.length;
    },
    isInactive() {
      return this.count ? false : true;
    }
  },
  watch: {
    checked: {
      handler() {
        this.resetError();
      }
    }
  },
  methods: {
    accept() {
      if (this.isInactive || this.isProcessing.accept) {
        return;
      }
      this.isProcessing.accept = true;
      this.resetError();

      // 利用量を取得
      this.getUsages()
        .then(response => {
          Promise.all(
            this.checked.map(item => {
              return this.postLog(item, 'accept').then(() => {
                return this.postTask(item).then(() => {
                  this.$emit('submit', item);
                });
              });
            })
          ).finally(() => {
            this.$store.dispatch('project/getTaskCount');
            this.$emit('submitAll');
            this.isProcessing.accept = false;
          });
        })
        .catch(error => {
          this.isProcessing.accept = false;
        });
    },
    reject() {
      if (this.isInactive || this.isProcessing.reject) {
        return;
      }
      this.isProcessing.reject = true;
      this.resetError();

      Promise.all(
        this.checked.map(item => {
          return this.postLog(item, 'reject').then(() => {
            this.$emit('submit', item);
          });
        })
      ).finally(() => {
        this.$emit('submitAll');
        this.isProcessing.reject = false;
      });
    },
    getUsages() {
      const params = {
        items: 'tasks'
      };
      return apiProjects.usages
        .get(params, this.auth.idToken, this.project.id)
        .then(response => {
          const usages = response.data.items[0]; //登録数
          const usagesRest = usages.max - usages.current;
          if (usagesRest <= 0) {
            this.errorResponses.accept.push(
              `${USAGE_LABEL['tasks']}の上限を超えています。登録するにはタスクを削除してください`
            );
          } else if (usagesRest < this.count) {
            this.errorResponses.accept.push(
              `${USAGE_LABEL['tasks']}の上限を超えています。登録できるのは${usagesRest}件までです`
            );
            this.usages.rest = usagesRest;
            this.isOver = true;
          }
          if (this.errorResponses.accept.length) {
            return Promise.reject();
          }
        })
        .catch(error => {
          if (error.response) {
            this.errorResponses.accept = [
              error.response.data.errors[0].userMessage
            ];
          }
          throw error;
        });
    },
    postLog(item, status) {
      const params = {
        date: this.$options.filters.dateText(utils.getDateResetHours()),
        keyword: item.keyword,
        type: this.type,
        url: item.url,
        isNeed: status === 'accept' ? true : false
      };

      if (this.type === 'seoCheckUp') {
        params.category = item.category;
        params.content = item.content;
      }

      return apiProjects.proposals.log
        .post(params, this.auth.idToken, this.project.id)
        .catch(error => {
          if (error.response) {
            this.errorResponses[status].push(
              error.response.data.errors[0].userMessage
            );
          }
          throw error;
        });
    },
    postTask(item) {
      const taskDetail = utils.getProposalTaskDetail({
        content: item.content,
        keyword: item.keyword,
        type: this.type,
        url: item.url
      });
      const params = {
        column: 'todo',
        operatorUserId: null,
        proposalId: item.id,
        taskDetail: taskDetail,
        type: this.type,
        isProposal: true
      };
      return apiProjects.tasks.siteAnalysis
        .post(params, this.auth.idToken, this.project.id)
        .catch(error => {
          if (error.response) {
            this.errorResponses.accept.push(
              error.response.data.errors[0].userMessage
            );
          }
          throw error;
        });
    },
    resetError() {
      if (!this.isOver || this.usages.rest >= this.count) {
        this.errorResponses.accept = [];
        this.errorResponses.reject = [];
        this.isOver = false;
      }
    }
  }
};
</script>
